module.exports = __webpack_public_path__ + "img/DB_Active.ff5e0849.png";